<template>
    <div id="s-menuSave">
    <!--Espace du menu en haut des pages ets déterminé dans le fichier App.vue / css : .cont_css -->

<!--
    ''  = Régulier
    '-' = Spinner
    '1' = Message : Ok
    '2' = Message : Erreur
    '3' = Confirmation - suppression
    '4' = Chargement
    '5' = Recherche
    '6' = Confirmation - general

    customBtn1 = bouton custom, 
        customBtn1: Boolean - faire apparaitre le bouton
        customText1: String - texte du bouton
        customColor1: String - couleur du bouton
        custom1 = fonction retourné
-->

<!--<span class="menuSaveTitle">Fiche client</span>-->

<!--<b-row v-if="status==''" :style="'height: ' + menuHeight + 'px;'" class="mainSpace mainSpaceReg btnAlign" align-h="end">-->
                <b-row :class="'mainSpace mainSpaceReg ' + getAllSize.saveMenuHeight">

                    <!--TITRE - VISIBLE SEULEMENT EN VERSION DESKTOP-->
                    <b-col cols=4>
                        <div v-show="!mobile" style="width:50%; height: 100%; display: flex; align-items: center; justify-content: start; padding-left: 10px">
                            <span class="menuSaveTitle" @click="alBtnChange()">{{this.$route.name}}</span>
                        </div>
                    </b-col>
                    <!--FIN - TITRE - VISIBLE SEULEMENT EN VERSION DESKTOP-->

                    <!--<div class="btnAlign" :style="alBtn">-->
                    <b-col cols=3 style="padding-top:3px; padding-left:15px;">
                        <div v-if="status==''" :class="mobile == false ? 'btnAlign':'btnAlignMobile'"> <!--:style="alBtn">  -  cause un bug d'affichage-->
                            <!--NEW-->
                            <s-button 
                                style="padding-right: 5px"
                                v-show="newBtn" 
                                id="newBtn" 
                                name="newBtn" 
                                @click.native="$emit('new')"
                                text="g_Nouveau"
                                color="main">
                            </s-button>
                            <!--SAVE-->
                            <s-button 
                                style="padding-right: 5px"
                                v-show="saveBtn" 
                                id="saveBtn" 
                                name="saveBtn" 
                                @click.native="$emit('save')"
                                text="g_Enregistrer"
                                color="green"
                                :disabled="btnSaveDisabled">
                            </s-button>
                            <!--DELETE-->
                            <!-- <s-button
                                style="padding-right: 5px"
                                v-show="deleteBtn" 
                                id="btnDelete" 
                                name="btnDelete" 
                                @click.native="msg='3'"
                                text="g_Supprimer"
                                color="red"
                                :disabled="deleteBtn">
                            </s-button> -->
                            <s-button
                                style="padding-right: 5px" 
                                v-show="deleteBtn" 
                                id="btnDelete" 
                                name="btnDelete" 
                                @click.native="msg='3'"
                                text="g_Supprimer"
                                color="red"
                                :disabled="!deleteBtn">
                            </s-button>
                            <!--PRINT-->
                            <s-button 
                                style="padding-right: 5px"
                                v-show="printBtn" 
                                id="printBtn" 
                                name="printBtn" 
                                text="g_Imprimer"
                                color="gray">
                            </s-button>
                            <!--CUSTOM--><!--voir a faire en sorte qu'on puisse mettre texte autre que du fichier langue-->
                            <s-button 
                                style="padding-right: 5px"
                                v-show="customBtn1" 
                                id="btnCustom1" 
                                name="btnCustom1" 
                                @click.native="$emit('custom1')"
                                :text="customText1" 
                                color="gray">
                            </s-button>
                        </div>
                        <div v-else-if="status=='-'" :class="mobile == false ? 'btnAlign':'btnAlignMobile'">
                            <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                            <b-spinner type="grow" :variant="getTheme.danger"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                        </div>                
                        <div v-else-if="status=='1'" :class="mobile == false ? 'btnAlign':'btnAlignMobile'" @click="msg=''">
                            <span class="txtSize">{{$t('g_Ok')}}</span>
                        </div>                
                        <div v-else-if="status=='2'" :class="mobile == false ? 'btnAlign':'btnAlignMobile'" @click="msg=''">
                            <span class="txtSize">{{$t('g_Erreur')}}</span>
                        </div>                
                        <div v-else-if="status=='3'" :class="mobile == false ? 'btnAlign':'btnAlignMobile'" @click="msg=''">
                            <b-button v-show="newBtn" class="btnConfirm" id="btnCancel" name="btnCancel" :variant="getTheme.success" @click="$emit('new')">{{$t('g_Annuler')}}</b-button>                                
                            <b-button v-show="deleteBtn" class="btnConfirm" id="btnDeleteConfirm" name="btnDeleteConfirm" :variant="getTheme.danger" @click="$emit('delete')">{{$t('g_Confirmer')}}</b-button>
                        </div> 
                        <div v-else-if="status=='4'">
                            <b-spinner small type="grow" :variant="getTheme.light"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.dark"></b-spinner>
                            <span class="txtLoad">{{$t('g_ChargementEnCours')}}</span>
                            <b-spinner small type="grow" :variant="getTheme.dark"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.light"></b-spinner>
                        </div>
                        <span v-else-if="status=='5'" >
                            <b-spinner small type="grow" :variant="getTheme.light"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.dark"></b-spinner>
                            <span class="txtLoad">{{$t('g_Recherche')}}</span>
                            <b-spinner small type="grow" :variant="getTheme.dark"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.light"></b-spinner>
                        </span> 
                        <div v-else-if="status=='6'" :class="mobile == false ? 'btnAlign':'btnAlignMobile'" @click="msg=''">
                            <b-button  class="btnConfirm" id="btnCancel" name="btnCancel" :variant="getTheme.success" @click="$emit('new')">{{$t('g_Annuler')}}</b-button>                                
                            <b-button  class="btnConfirm" id="btnDeleteConfirm" name="btnDeleteConfirm" :variant="getTheme.danger" @click="$emit('customEmit')">{{$t('g_Confirmer')}}</b-button>
                        </div> 
                        <span v-else :class="mobile == false ? 'btnAlign':'btnAlignMobile'">
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <span class="txtLoad">{{' ' + status + ' '}}</span>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                        </span>   
                    </b-col>
                   
                    <!--<b-button v-show="applyBtn" class="btnDelete" id="btnDelete" name="btnDelete" :variant="getTheme.warning" @click="msg='3'">{{$t('g_Supprimer')}}</b-button>
                    <b-button v-show="annulerBtn" class="btnDelete" id="btnDelete" name="btnDelete" :variant="getTheme.warning" @click="msg='3'">{{$t('g_Supprimer')}}</b-button>
                    <b-button v-show="dupliquerBtn" class="btnDelete" id="btnDelete" name="btnDelete" :variant="getTheme.warning" @click="msg='3'">{{$t('g_Supprimer')}}</b-button>-->
                    <b-col cols=5>
                        <!--<div class="alertBack">
                            test
                        </div>-->
                        <div v-if="msgType==getTheme.primary">
                            <marquee  class="msgBox msgBoxPrimary" behavior="scroll" direction="left" scrollamount="7">
                                {{msgText}}
                            </marquee>
                        </div>
                        <div v-else-if="msgType==getTheme.warning">
                            <marquee class="msgBox msgBoxWarning" behavior="scroll" direction="left" scrollamount="7">
                                {{msgText}}
                            </marquee>
                        </div>

                    </b-col>
                </b-row>

                         
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import mobileNav from '../../../mixins/mobileNav.js'

export default{
    name: 's-menuSave',
    mixins:[mobileNav],
    components: {
        
    },
    props: {
        newBtn: Boolean,
        saveBtn: Boolean,
        deleteBtn: Boolean,
        printBtn: Boolean,
        btnSaveDisabled: Boolean,
        //msg: String,
        applyBtn: Boolean,
        annulerBtn: Boolean,
        dupliquerBtn: Boolean,
        customBtn1: Boolean,
        customText1: String,
        customColor1: String,
        customEmit: String,
        msgType: String,
        msgText: String,
    },
    data() {
        return {
            size: 'sm',
            alBtn: 'start',
            msg : "",
        }
    },
    created(){
        window.addEventListener("resize", this.alBtnChange);
        this.alBtnChange();
    },
    methods: {
        alBtnChange(){
            if(this.mobile == false)
                {
                    if (this.alBtn == 'justify-content: start;')
                        {this.alBtn = 'justify-content: end;'}
                    else 
                        {this.alBtn = 'justify-content: start;'}
                }
            else
                {
                    this.alBtn == ''
                }
        }
    },
    computed: {
        ...mapGetters(['getTheme', 'getAllSize']),
        status() {
            return this.msg
        },
        //menuHeight() {
        //    if(this.getAllSize == 'sm')
        //    {return 34;}
        //    else if(this.getAllSize == 'md')
        //    {return 39;}
        //    else if(this.getAllSize == 'lg')
        //    {return 47;}
        //    else
        //    {return 47}
        //}
    }
}
</script>

<style lang="scss" scoped>
@import './menuSave.scss';
@import './menuSaveMsgBox.scss';
</style>